import React from "react";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Get In Touch"
        title={["LET'S SWITCH", "YOUR HOME", "ON TO SOLAR."]}
        subtitle="Reach either Selectra Solar location directly, or send a message and our team will route it for you."
      />
      <Contact />
    </>
  );
}
